<template>
    <div class="wework-account-unbind">
        <div class="wework-account-unbind-images"></div>
        <h2 v-if="hasStepList" class="wework-account-unbind-titles">绑定企业微信账号，开始使用企业微信相关能力</h2>
        <h2 v-else class="wework-account-unbind-titles">请开通以下任一功能模块后再绑定企业微信账号</h2>
        <div class="wework-account-unbind-txt">
            包括
            <!-- <span>客户通</span> -->
            <a style="cursor: pointer;" @click="externalJump('https://qidian.qq.com/module/wxservice.html')">
                微信客服</a
            >
            <!-- <span>微信客服</span> -->
            <a style="cursor: pointer;" @click="externalJump('https://qidian.qq.com/solution/sscindex.html')">
                企业共享服务中心</a
            >
            <!-- <span>企业共享服务中心</span> -->
            <!-- <span>企业微信机器人</span> -->
            等
        </div>
        <v-button v-if="hasStepList" status="primary" size="large" class="wework-account-unbind-btn" @click="bindClick"
            >立即绑定</v-button
        >
    </div>
</template>

<script>
import setFlowNext from '@/pages/mng/third_account/weworkCombine/api/setFlowNext';

export default {
    props: {
        hasStepList: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {};
    },

    created() {},

    methods: {
        externalJump(path) {
            window.open(path, '_blank');
        },
        bindClick() {
            setFlowNext('guide')
                .then(() => {
                    window.location.reload();
                })
                .catch(msg => {
                    this.$message.error(msg || '开启绑定错误');
                });
        }
    }
};
</script>
<style scoped lang="less">
@import './account-unbind.less';
</style>
